import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { PATH_DASHBOARD } from '@/routes/paths';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from '@/commons/snackbar';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserUid, putUsers } from '@/services';
import { translates } from '@/utils';
import { TITLE } from '@/utils/constants';
import { IUserAccountGeneral } from '../types';
import UserNewEditForm from '../form/user';

export default function UserEditPage() {
  const navigate = useNavigate();
  const { uid } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { mutateAsync, isSuccess } = useMutation({
    mutationKey: ['users', uid!],
    mutationFn: putUsers(uid!),
    onSuccess: (data: IUserAccountGeneral) => {
      queryClient.setQueryData(['users', data?.id || ''], data);
      queryClient.invalidateQueries({ queryKey: ['users'] });
      enqueueSnackbar('Edit success user!');
      navigate(PATH_DASHBOARD.users.list);
    },
    onError: (error: any) => {
      enqueueSnackbar(error, { variant: 'error' });
    },
  });

  const { data } = useQuery({
    queryKey: ['users', uid!],
    queryFn: async () => getUserUid(uid!),
  });

  return (
    <>
      <Helmet>
        <title> {TITLE}: Edit user </title>
      </Helmet>

      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={`${translates.edit} ${translates.user}`}
          links={[
            {
              name: translates.dashboard,
              href: PATH_DASHBOARD.root,
            },
            {
              name: translates.user,
              href: PATH_DASHBOARD.users.list,
            },
            { name: `${translates.edit} ${translates.user}` },
          ]}
        />
        <UserNewEditForm onSave={mutateAsync} isEdit current={data as any} isLoading={!isSuccess} />
      </Container>
    </>
  );
}
